const translations = {
  // Nav
  "nav.home": "Startseite",
  "nav.mission": "Mission",
  "nav.projects": "Projekte",
  "nav.volunteer": "Ehrenamt",
  "nav.donate": "Spenden",
  "nav.contact": "Kontakt",
  "nav.donateNow": "Jetzt spenden",

  // Language bar
  "lang.managed": "Verwaltet über das Admin-CMS-Dashboard",

  // Hero
  "hero.badge": "Brücken bauen · Hoffnung schaffen",
  "hero.title": "Afghanische Gemeinschaften durch Bildung und Chancen stärken",
  "hero.subtitle": "Die Canada Afghanistan Foundation verbindet mitfühlende Kanadier mit bedürftigen afghanischen Gemeinschaften — Finanzierung von Bildung, Gesundheitsversorgung und nachhaltiger Entwicklung seit 2016.",
  "hero.cta.donate": "Unsere Mission unterstützen",
  "hero.cta.learn": "Unsere Geschichte",
  "hero.scroll": "Scrollen",

  // Mission Preview
  "mission.tag": "Unsere Mission",
  "mission.title": "Eine Brücke zwischen zwei Nationen, gebaut auf Mitgefühl",
  "mission.body1": "Die Canada Afghanistan Foundation (CAF) ist eine registrierte kanadische Wohltätigkeitsorganisation, die sich der Verbesserung des Lebens der Afghanen durch gezielte Programme in Bildung, Gesundheitsversorgung und Gemeindeentwicklung widmet.",
  "mission.body2": "Wir glauben, dass jedes afghanische Kind Zugang zu Bildung verdient, jede Familie sauberes Wasser verdient und jede Gemeinschaft die Chance verdient zu gedeihen — unabhängig von Konflikten.",
  "mission.cta": "Unsere vollständige Mission lesen",
  "mission.pillar.education": "Bildung",
  "mission.pillar.education.desc": "Finanzierung von Schulen, Stipendien und Berufsausbildung für afghanische Jugendliche und Frauen.",
  "mission.pillar.healthcare": "Gesundheit",
  "mission.pillar.healthcare.desc": "Einsatz mobiler Kliniken und Unterstützung medizinischer Fachkräfte in unterversorgten Regionen.",
  "mission.pillar.community": "Gemeinschaft",
  "mission.pillar.community.desc": "Aufbau von Infrastruktur, Zugang zu sauberem Wasser und Unterstützung der Flüchtlingsumsiedlung in Kanada.",
  "mission.pillar.sustainability": "Nachhaltigkeit",
  "mission.pillar.sustainability.desc": "Stärkung lokaler Führungskräfte und Organisationen für dauerhaften, selbsttragenden Wandel.",

  // Projects Preview
  "projects.tag": "Aktive Initiativen",
  "projects.title": "Unsere aktuellen Projekte",
  "projects.subtitle": "Jedes Projekt ist sorgfältig darauf ausgelegt, nachhaltige Wirkung in afghanischen Gemeinschaften zu erzielen.",
  "projects.viewAll": "Alle Projekte anzeigen",
  "projects.learnMore": "Mehr erfahren",
  "projects.raised": "Gesammelt",
  "projects.completed": "Abgeschlossen",

  // Impact
  "impact.tag": "Unsere Wirkung",
  "impact.title": "Echter Wandel, echte Zahlen",
  "impact.subtitle": "Jeder gespendete Dollar führt zu messbarer Wirkung vor Ort. Das haben wir gemeinsam erreicht.",
  "impact.students": "Unterstützte Schüler",
  "impact.students.desc": "Mädchen und Jungen, die durch unsere Stipendien- und Schulprogramme Qualitätsbildung erhalten.",
  "impact.water": "Menschen mit sauberem Wasser",
  "impact.water.desc": "Familien im ländlichen Afghanistan haben jetzt Zugang zu sicherem, sauberem Trinkwasser.",
  "impact.medical": "Medizinische Konsultationen",
  "impact.medical.desc": "Kostenlose Gesundheitsversorgung durch unser mobiles Klinikprogramm seit 2018.",
  "impact.families": "Umgesiedelte Familien",
  "impact.families.desc": "Afghanische Flüchtlingsfamilien, die in ihrem neuen Leben in Kanada unterstützt werden.",

  // Volunteer Preview
  "volunteer.tag": "Mitmachen",
  "volunteer.title": "Treten Sie unserer Gemeinschaft von Veränderern bei",
  "volunteer.body1": "Ob Arzt, Übersetzer, Fundraiser oder Social-Media-Enthusiast — bei der CAF ist Platz für Sie. Ihre Fähigkeiten können Leben verändern.",
  "volunteer.body2": "Wir haben Freiwilligenmöglichkeiten für Kanadier und Mitglieder der afghanischen Diaspora, sowohl remote als auch vor Ort.",
  "volunteer.cta": "Freiwilliger werden",
  "volunteer.otherWays": "Oder erkunden Sie andere Möglichkeiten zu helfen",
  "volunteer.apply": "Bewerben",
  "volunteer.location": "Ort",

  // Donate Preview
  "donate.tag": "Einen Unterschied machen",
  "donate.title": "Ihre Spende, ihre Zukunft",
  "donate.subtitle": "100% Ihrer Spende fließt direkt in Programme vor Ort. Wir sind eine registrierte kanadische Wohltätigkeitsorganisation — alle Spenden sind steuerlich absetzbar.",
  "donate.tier.supporter": "Unterstützer",
  "donate.tier.champion": "Champion",
  "donate.tier.patron": "Mäzen",
  "donate.mostPopular": "Am beliebtesten",
  "donate.highImpact": "Hohe Wirkung",
  "donate.donate": "Spenden",
  "donate.trust.charity": "Registrierte kanadische Wohltätigkeitsorganisation",
  "donate.trust.transparent": "100% Transparent",
  "donate.trust.receipts": "Steuerquittungen ausgestellt",
  "donate.trust.secure": "Sichere Verarbeitung",

  // Footer
  "footer.tagline": "Brücken zwischen Kanada und Afghanistan durch Bildung, Gesundheitsversorgung und Gemeindeentwicklung bauen.",
  "footer.charity": "CRA Registrierte Wohltätigkeitsorganisation #123456789",
  "footer.est": "Gegr. 2016",
  "footer.quickLinks": "Schnelllinks",
  "footer.getInvolved": "Mitmachen",
  "footer.stayConnected": "Verbunden bleiben",
  "footer.newsletter.desc": "Erhalten Sie monatliche Updates über unsere Wirkung und wie Sie helfen können.",
  "footer.newsletter.placeholder": "Ihre E-Mail-Adresse",
  "footer.newsletter.success": "Vielen Dank für Ihre Anmeldung!",
  "footer.newsletter.privacy": "Wir respektieren Ihre Privatsphäre. Jederzeit abmelden.",
  "footer.support": "Support verfügbar in:",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.terms": "Nutzungsbedingungen",
  "footer.accessibility": "Barrierefreiheit",
  "footer.admin": "Admin",
  "footer.copyright": "Canada Afghanistan Foundation. Alle Rechte vorbehalten.",

  // Contact
  "contact.tag": "Kontakt aufnehmen",
  "contact.title": "Wir freuen uns von Ihnen zu hören",
  "contact.subtitle": "Fragen zu unseren Programmen oder möchten Sie mit uns zusammenarbeiten? Kontaktieren Sie uns — wir antworten auf Englisch, Paschtu, Dari, Französisch und Deutsch.",
  "contact.form.name": "Vollständiger Name",
  "contact.form.email": "E-Mail-Adresse",
  "contact.form.subject": "Betreff",
  "contact.form.message": "Ihre Nachricht",
  "contact.form.submit": "Nachricht senden",
  "contact.form.sending": "Wird gesendet...",
  "contact.form.success": "Nachricht gesendet! Wir melden uns innerhalb von 48 Stunden.",
  "contact.info.address": "Adresse",
  "contact.info.email": "E-Mail",
  "contact.info.phone": "Telefon",
  "contact.info.hours": "Bürozeiten",

  // Mission Page
  "missionPage.tag": "Unsere Mission",
  "missionPage.title": "Eine Mission verwurzelt in Hoffnung, angetrieben von Handeln",
  "missionPage.subtitle": "Die Canada Afghanistan Foundation existiert, um die Lücke zwischen mitfühlenden Kanadiern und bedürftigen afghanischen Gemeinschaften zu überbrücken.",
  "missionPage.who.tag": "Wer wir sind",
  "missionPage.who.title": "Brücken zwischen zwei Nationen bauen",
  "missionPage.values.tag": "Was uns leitet",
  "missionPage.values.title": "Unsere Grundwerte",
  "missionPage.timeline.tag": "Unsere Reise",
  "missionPage.timeline.title": "8 Jahre Wirkung",
  "missionPage.cta.title": "Teil der Mission sein",
  "missionPage.cta.subtitle": "Ob Sie spenden, ehrenamtlich tätig sind oder einfach das Wort verbreiten — Sie sind Teil des Wandels.",
  "missionPage.cta.donate": "Jetzt spenden",
  "missionPage.cta.volunteer": "Freiwilliger werden",

  // Donate Page
  "donatePage.tag": "Unsere Arbeit unterstützen",
  "donatePage.title": "Nachhaltige Wirkung erzielen",
  "donatePage.subtitle": "Ihre Großzügigkeit finanziert echte Programme, die echte Leben verändern.",

  // Volunteer Page
  "volunteerPage.tag": "Ehrenamt bei der CAF",
  "volunteerPage.title": "Ihre Fähigkeiten können Leben verändern",
  "volunteerPage.subtitle": "Treten Sie unserem globalen Netzwerk engagierter Freiwilliger bei, die einen Unterschied für afghanische Gemeinschaften machen.",
};

export default translations;
